import { styled } from '@mui/material/styles'
import { grayBg, grayBorder, grayText, defaultText } from '@/constant'
import menu_bg from '@/asset/img/menu_bg.webp'

export const MenuPage = styled('div')(() => ({
  display: 'flex',
  height: '100% ',
  paddingTop: '48px',
  backgroundColor: grayBg,
  // borderTop: `1px solid ${grayBorder}`,
}))

export const Main = styled('div')(() => ({
  flex: 1,
  padding: '24px',
  paddingBottom: '0',
  overflowY: 'initial',
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
}))

export const SideMenu = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  borderRight: `1px solid ${grayBorder}`,
  backgroundColor: '#fff',
  padding: '16px 0px',
  gap: '8px',
  backgroundImage: `url(${menu_bg})`,
  backgroundPosition: 'bottom',
  backgroundRepeat: 'no-repeat',
  backgroundSize: '105%',
}))

export const SubMenu = styled('div', {
  shouldForwardProp: (prop) => prop !== 'expand' && prop !== 'height',
})<{ expand: string; height: number | string }>(({ expand, height }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  gap: '12px',
  height: 0,
  transition: 'height 0.2s linear',
  overflow: 'hidden',
  ...(expand === 'true' && {
    height: height ?? 'auto',
    transition: 'height 0.2s linear',
  }),
}))

export const Breadcrumbs = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  gap: '4px',
  marginTop: '16px',
}))

export const BreadcrumbsItem = styled('div')(() => ({
  color: grayText,
  cursor: 'pointer',
  '&:hover': {
    color: defaultText,
  },
  fontSize: '14px',
}))

export const Tag = styled('div', {
  shouldForwardProp: (prop) => prop !== 'highlight',
})<{ highlight: 'true' | 'false' }>(({ highlight }) => ({
  display: 'inline-block',
  width: '24px',
  lineHeight: '14px',
  fontSize: '10px',
  borderRadius: '4px',
  textAlign: 'center',
  color: '#fff',
  backgroundColor: '#FF665D',
  ...(highlight === 'true' && { color: '#FF665D', backgroundColor: '#fff' }),
}))

export const ScrollY = styled('div')(() => ({
  height: '100%',
  overflow: 'auto',
  ...(navigator?.userAgent?.indexOf('Chrome') != -1 && { overflow: 'overlay' }),
}))
